import PropTypes from 'prop-types'
import React from 'react'

const WordpressImage = ({
  className,
  maxWidth,
  img: { alt: imgAlt, height, width, sizes, url },
  alt
}) => {
  let imgSrc = url
  let srcsetString
  let sizesString = '100vh'
  if (sizes) {
    // TODO: if multiple images larger than maxWidth, could drop all but the smallest of them
    srcsetString = ['thumbnail', 'medium', 'mediumLarge', 'large']
      .map(dimension => {
        if (sizes[dimension] && sizes[dimension + 'Width']) {
          return sizes[dimension] + ' ' + sizes[dimension + 'Width'] + 'w'
        }
      })
      .filter(i => !!i)
      .join(',')

    if (maxWidth) {
      sizesString = `(max-width: ${maxWidth}px) ${maxWidth}px, ` + sizesString
    }
  }
  return (
    <img
      className={className}
      src={imgSrc}
      alt={alt || imgAlt || undefined}
      srcSet={srcsetString}
      sizes={sizesString}
    />
  )
}

WordpressImage.propTypes = {
  className: PropTypes.string,
  maxWidth: PropTypes.number,
  img: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  alt: PropTypes.string
}

export default WordpressImage



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/WordpressImage.js